import {
  DATE_INFERRED_DEPARTURE_EXPLANATION,
  dateInferredDepartureNote,
} from '../utils/derivedDepartures';
import { DepartureProvenanceNote } from './DepartureProvenanceNote';

/**
 * Sibling of DerivedDepartureNote for exits the roster dated but gave no
 * reason for (spec-exit-date-inference §4.2).
 */
export function DateInferredDepartureNote({ count, color }: { count: number; color: string }) {
  return (
    <DepartureProvenanceNote
      count={count}
      color={color}
      testId="date-inferred-departure-note"
      note={dateInferredDepartureNote}
      explanation={DATE_INFERRED_DEPARTURE_EXPLANATION}
    />
  );
}
